import classNames from 'classnames';
import React from 'react';
import Toggle from './Components/Toggle';
import styles from './styles.module.scss';
export let TooltipDirection;

(function (TooltipDirection) {
  TooltipDirection["TOP"] = "top";
  TooltipDirection["RIGHT"] = "right";
  TooltipDirection["BOTTOM"] = "bottom";
  TooltipDirection["LEFT"] = "left";
})(TooltipDirection || (TooltipDirection = {}));

const Tooltip = /*#__PURE__*/React.forwardRef((_, ref) => {
  const [title, setTitle] = React.useState('');
  const [isDisplay, setIsDisplay] = React.useState(false);
  const [position, setPosition] = React.useState({
    top: 0,
    left: 0
  });
  const [tipDirection, setTipDirection] = React.useState(TooltipDirection.BOTTOM);
  const [styleConfigs, setStyleConfigs] = React.useState({
    backgroundColor: '#fff',
    textColor: '#000',
    delay: 0
  });

  const display = (title, position, direction, styleOptions) => {
    setPosition(position);
    setTitle(title);
    setIsDisplay(true);
    setTipDirection(direction || TooltipDirection.BOTTOM);
    setStyleConfigs({ ...styleConfigs,
      ...styleOptions
    });
  };

  const hide = () => {
    setIsDisplay(false);
  };

  React.useEffect(() => {
    if (isDisplay && !!styleConfigs.delay) {
      const timer = setTimeout(() => setIsDisplay(false), styleConfigs.delay);
      return () => clearTimeout(timer);
    }

    return undefined;
  }, [isDisplay]);
  React.useImperativeHandle(ref, () => {
    return {
      display,
      hide
    };
  });

  const getDirectionStyle = () => {
    switch (tipDirection) {
      case TooltipDirection.TOP:
        return styles.top;

      case TooltipDirection.BOTTOM:
        return styles.bottom;

      case TooltipDirection.LEFT:
        return styles.left;

      case TooltipDirection.RIGHT:
        return styles.right;

      default:
        return styles.bottom;
    }
  };

  return isDisplay ? /*#__PURE__*/React.createElement(Toggle, {
    top: position.top,
    left: position.left,
    className: classNames(styles.tip, getDirectionStyle(), tipDirection),
    styleOptions: {
      width: styleConfigs.width,
      backgroundColor: styleConfigs.backgroundColor,
      textColor: styleConfigs.textColor
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.contentWrapper
  }, title)) : null;
});
Tooltip.displayName = 'Tooltip';
export default Tooltip;